<h2 mat-dialog-title>Create Note</h2>
<div mat-dialog-content>
  <div>
    <form [formGroup]="createNotesForm">
      <mat-form-field style="width: 100%; margin-bottom: 16px;" appearance="outline">
        <mat-label>Note</mat-label>
        <textarea matInput  placeholder=" Enter Your Note" formControlName="note"></textarea>
        <mat-error
          *ngIf="createNotesForm.controls['note'].touched && createNotesForm.controls['note'].hasError('required')">
          This is a required field.</mat-error>
      </mat-form-field>
      <div class="buttonarea">
        <button type="button" color="primary" mat-raised-button (click)="craeteNotes()">
          <span> Submit </span>
        </button>
       <button class="buttonclose" mat-button mat-dialog-close>Close</button>
        
      </div>
    </form>
  </div>
</div>



